export const SENT_STATUSES = ['new']
export const OPENED_STATUSES = ['reviewed']
export const SCHEDULED_STATUSES = ['payment_source_assigned']
export const CARD_DECLINED_STATUSES = ['overdue']
export const FUNDS_ON_THE_WAY_STATUSES = [
  'paid',
  'merchant_proceeds_transferred',
]
export const SETTLED_STATUSES = ['merchant_payout_processed']
export const CANCELED_STATUSES = ['canceled']
export const EXPIRED_STATUSES = ['expired']

const getState = status => {
  if (SENT_STATUSES.includes(status)) {
    return 'sent'
  }
  if (OPENED_STATUSES.includes(status)) {
    return 'opened'
  }
  if (SCHEDULED_STATUSES.includes(status)) {
    return 'scheduled'
  }
  if (CARD_DECLINED_STATUSES.includes(status)) {
    return 'card_declined'
  }
  if (FUNDS_ON_THE_WAY_STATUSES.includes(status)) {
    return 'funds_on_the_way'
  }
  if (SETTLED_STATUSES.includes(status)) {
    return 'settled'
  }
  if (CANCELED_STATUSES.includes(status)) {
    return 'canceled'
  }
  if (EXPIRED_STATUSES.includes(status)) {
    return 'expired'
  }
  return status
}

const normalizeActivity = transaction => {
  const { stateMachineTransitions = [], createdAt } = transaction
  stateMachineTransitions.unshift({
    to: 'new',
    at: createdAt,
    state: 'sent',
    uuid: '234923840328',
  })
  return stateMachineTransitions
}

const normalize = bill => {
  const activity = normalizeActivity(bill)
  const state = getState(bill.status)

  const pronouns = {
    consumerHeShe: bill.consumerGender === 'm' ? 'he' : 'she',
    consumerHisHer: bill.consumerGender === 'm' ? 'his' : 'her',
  }

  return {
    ...bill,
    activity,
    state,
    ...pronouns,
  }
}

export default normalize
